import * as TYPES from '../actions/types';

const initialState = {
    visible: false,
    message: "",
    title: "",
    type: ""
}

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case TYPES.ALERT_SHOW:
            return {
                ...action.payload,
                visible: true
            };
        case TYPES.ALERT_HIDE:
            return {
                visible: false
            }
        default:
            return state;
    }
}

export default reducer;